export enum CategoryActionTypes {
    API_RESPONSE_SUCCESS = '@@category/API_RESPONSE_SUCCESS',
    API_RESPONSE_ERROR = '@@category/API_RESPONSE_ERROR',

    GET_CATEGORIES = '@@category/GET_CATEGORIES',
    GET_CATEGORY_TREE = '@@category/GET_CATEGORY_TREE',
    GET_CATEGORY_PRODUCTS = '@@category/GET_CATEGORY_PRODUCTS',
    CREATE_CATEGORY = '@@category/CREATE_CATEGORY',
    UPDATE_CATEGORY = '@@category/UPDATE_CATEGORY',
    DELETE_CATEGORY = '@@category/DELETE_CATEGORY',
}
